/**
 * Survey map
 */

(function($) {

    if ( typeof vous_l10n === 'undefined' ) { // Ensure l10n is set
        return;
    }
    if ( typeof vous_l10n.survey_form_id === 'undefined' || ! vous_l10n.survey_form_id ) { // Ensure script is enabled
        return;
    }

    // Triggers when page is loaded
    $(document).on('gform_page_loaded', function(event, form_id, current_page) {
        if ( form_id != vous_l10n.survey_form_id ) { // Apply only to the survey form
            return;
        }

        const $page = $('.js-survey-page-map');
        if ( $page.filter(':visible').length == 0 ) { // Apply only to the map page
            return;
        }

        // Interactive map provides a way to select region from list of options
        const $map = $page.find('.js-survey-map');
        if ( $map.length ) {
            // Highlight region on map for option selected on page load
            const $options = $page.find('.js-map-options .gfield_radio li');
            let index = $options.find('input[type="radio"]:checked').closest('li').index();
            $map.find(`g[data-option="${index}"]`).addClass('is-active');

            // Highlight region on map when an option is selected
            $options.on('change', 'input[type="radio"]', function() {
                const $this = $(this);
                let index = $this.closest('li').index();
                $map.find('g').removeClass('is-active');
                $map.find(`g[data-option="${index}"]`).addClass('is-active');
            });

            // Select option when region on map is clicked
            $map.on('click', 'g', function () {
                const $this = $(this);
                $this.addClass('is-active');
                $this.siblings().removeClass('is-active');
                let index = $this.data('option');
                $options.eq(index).find('label').trigger('click'); // Trigger click event on label
                $options.eq(index).find('input[type="radio"]').prop('checked', true);
            });
        }
    });

})(jQuery);
